export const categories = [
  { slug: 'football', name: '足球', icon: 'ri-football-line', count: 1280 },
  { slug: 'basketball', name: '篮球', icon: 'ri-basketball-line', count: 860 },
  { slug: 'tennis', name: '网球', icon: 'ri-base-station-line', count: 420 },
  { slug: 'esports', name: '电竞', icon: 'ri-gamepad-line', count: 650 },
  { slug: 'other', name: '其他赛事', icon: 'ri-riding-line', count: 310 },
];

export const featuredMatches = [
  { id: 1, league: '英超联赛', leagueIcon: 'ri-flag-2-line', time: '2026-08-08 03:00', homeTeam: '曼联', awayTeam: '利物浦', homeOdds: 2.45, drawOdds: 3.20, awayOdds: 2.80, status: 'upcoming', category: 'football', isHot: true },
  { id: 2, league: '西甲联赛', leagueIcon: 'ri-flag-2-line', time: '2026-08-08 01:30', homeTeam: '巴塞罗那', awayTeam: '皇家马德里', homeOdds: 2.10, drawOdds: 3.50, awayOdds: 3.10, status: 'upcoming', category: 'football', isHot: true },
  { id: 3, league: 'NBA常规赛', leagueIcon: 'ri-flag-2-line', time: '2026-08-08 08:00', homeTeam: '洛杉矶湖人', awayTeam: '金州勇士', homeOdds: 1.85, drawOdds: 0, awayOdds: 1.95, status: 'upcoming', category: 'basketball', isHot: true },
  { id: 4, league: '欧冠联赛', leagueIcon: 'ri-flag-2-line', time: '2026-08-09 03:00', homeTeam: '曼城', awayTeam: '拜仁慕尼黑', homeOdds: 1.75, drawOdds: 3.80, awayOdds: 4.20, status: 'upcoming', category: 'football', isHot: false },
  { id: 5, league: '法网公开赛', leagueIcon: 'ri-flag-2-line', time: '2026-08-08 18:00', homeTeam: '德约科维奇', awayTeam: '纳达尔', homeOdds: 1.55, drawOdds: 0, awayOdds: 2.40, status: 'upcoming', category: 'tennis', isHot: true },
  { id: 6, league: 'NBA常规赛', leagueIcon: 'ri-flag-2-line', time: '2026-08-08 10:30', homeTeam: '波士顿凯尔特人', awayTeam: '密尔沃基雄鹿', homeOdds: 1.65, drawOdds: 0, awayOdds: 2.20, status: 'upcoming', category: 'basketball', isHot: false },
  { id: 7, league: '意甲联赛', leagueIcon: 'ri-flag-2-line', time: '2026-08-09 00:00', homeTeam: 'AC米兰', awayTeam: '尤文图斯', homeOdds: 2.30, drawOdds: 3.10, awayOdds: 3.00, status: 'upcoming', category: 'football', isHot: false },
  { id: 8, league: 'LPL夏季赛', leagueIcon: 'ri-flag-2-line', time: '2026-08-08 17:00', homeTeam: 'JDG', awayTeam: 'BLG', homeOdds: 1.90, drawOdds: 0, awayOdds: 1.90, status: 'upcoming', category: 'esports', isHot: true },
];

export const matchDetails = {
  football: [
    { id: 101, league: '英超联赛', time: '2026-08-10 22:00', homeTeam: '阿森纳', awayTeam: '切尔西', homeOdds: 2.05, drawOdds: 3.40, awayOdds: 3.20, status: 'upcoming' },
    { id: 102, league: '英超联赛', time: '2026-08-10 22:00', homeTeam: '热刺', awayTeam: '纽卡斯尔', homeOdds: 2.15, drawOdds: 3.30, awayOdds: 3.10, status: 'upcoming' },
    { id: 103, league: '西甲联赛', time: '2026-08-11 04:00', homeTeam: '马德里竞技', awayTeam: '塞维利亚', homeOdds: 1.70, drawOdds: 3.60, awayOdds: 4.50, status: 'upcoming' },
    { id: 104, league: '德甲联赛', time: '2026-08-10 21:30', homeTeam: '多特蒙德', awayTeam: '莱比锡', homeOdds: 2.40, drawOdds: 3.30, awayOdds: 2.75, status: 'upcoming' },
    { id: 105, league: '法甲联赛', time: '2026-08-11 03:00', homeTeam: '巴黎圣日耳曼', awayTeam: '马赛', homeOdds: 1.45, drawOdds: 4.20, awayOdds: 6.00, status: 'upcoming' },
    { id: 106, league: '英超联赛', time: '2026-08-12 03:00', homeTeam: '利物浦', awayTeam: '曼城', homeOdds: 2.80, drawOdds: 3.40, awayOdds: 2.30, status: 'upcoming' },
  ],
  basketball: [
    { id: 201, league: 'NBA常规赛', time: '2026-08-11 09:00', homeTeam: '菲尼克斯太阳', awayTeam: '达拉斯独行侠', homeOdds: 1.75, drawOdds: 0, awayOdds: 2.05, status: 'upcoming' },
    { id: 202, league: 'NBA常规赛', time: '2026-08-11 11:00', homeTeam: '丹佛掘金', awayTeam: '洛杉矶快船', homeOdds: 1.60, drawOdds: 0, awayOdds: 2.30, status: 'upcoming' },
    { id: 203, league: 'CBA联赛', time: '2026-08-10 19:35', homeTeam: '广东宏远', awayTeam: '辽宁本钢', homeOdds: 1.85, drawOdds: 0, awayOdds: 1.95, status: 'upcoming' },
    { id: 204, league: 'NBA常规赛', time: '2026-08-12 08:00', homeTeam: '迈阿密热火', awayTeam: '费城76人', homeOdds: 2.10, drawOdds: 0, awayOdds: 1.72, status: 'upcoming' },
  ],
  tennis: [
    { id: 301, league: 'ATP巡回赛', time: '2026-08-10 16:00', homeTeam: '阿尔卡拉斯', awayTeam: '西西帕斯', homeOdds: 1.40, drawOdds: 0, awayOdds: 2.90, status: 'upcoming' },
    { id: 302, league: 'WTA巡回赛', time: '2026-08-11 14:00', homeTeam: '斯瓦泰克', awayTeam: '萨巴伦卡', homeOdds: 1.65, drawOdds: 0, awayOdds: 2.20, status: 'upcoming' },
    { id: 303, league: 'ATP巡回赛', time: '2026-08-10 18:00', homeTeam: '辛纳', awayTeam: '鲁德', homeOdds: 1.50, drawOdds: 0, awayOdds: 2.55, status: 'upcoming' },
  ],
  esports: [
    { id: 401, league: 'LPL夏季赛', time: '2026-08-10 17:00', homeTeam: 'TES', awayTeam: 'EDG', homeOdds: 1.72, drawOdds: 0, awayOdds: 2.10, status: 'upcoming' },
    { id: 402, league: 'LCK夏季赛', time: '2026-08-10 16:00', homeTeam: 'T1', awayTeam: 'GEN', homeOdds: 2.30, drawOdds: 0, awayOdds: 1.60, status: 'upcoming' },
    { id: 403, league: 'DOTA2国际赛', time: '2026-08-11 20:00', homeTeam: 'LGD', awayTeam: 'Team Spirit', homeOdds: 2.00, drawOdds: 0, awayOdds: 1.80, status: 'upcoming' },
  ],
  other: [
    { id: 501, league: 'F1大奖赛', time: '2026-08-12 20:00', homeTeam: '维斯塔潘', awayTeam: '汉密尔顿', homeOdds: 1.35, drawOdds: 0, awayOdds: 3.10, status: 'upcoming' },
    { id: 502, league: '拳击重量级', time: '2026-08-15 10:00', homeTeam: '约书亚', awayTeam: '富里', homeOdds: 2.50, drawOdds: 0, awayOdds: 1.55, status: 'upcoming' },
  ],
};

export const advantages = [
  { id: 1, icon: 'ri-flashlight-line', title: '极速存取款', desc: '支持多种支付方式，资金秒到账，提现最快5分钟到账，让您畅享无忧竞猜体验。' },
  { id: 2, icon: 'ri-shield-check-line', title: '安全稳定', desc: '采用银行级SSL加密技术，多重安全防护体系，确保用户信息和资金绝对安全。' },
  { id: 3, icon: 'ri-line-chart-line', title: '实时赔率', desc: '全球赛事赔率实时更新推送，智能算法精准分析，助您把握每一个最佳投注时机。' },
  { id: 4, icon: 'ri-smartphone-line', title: '多端支持', desc: '网页版、iOS APP、安卓APP全覆盖，数据实时同步，随时随地畅享顶级赛事竞猜。' },
  { id: 5, icon: 'ri-customer-service-2-line', title: '7×24客服', desc: '专业客服团队全天候在线，快速响应每一位用户的咨询与需求，服务零等待。' },
];

export const articles = [
  {
    id: 1,
    title: '2026欧洲杯预选赛全面解析：各队实力分析与竞猜指南',
    slug: 'uefa-euro-2026-qualifying-analysis',
    excerpt: '2026欧洲杯预选赛即将打响，本文为您全面解析各参赛队伍的实力状况、关键球员以及战术打法，助您在皇冠体育进行更精准的赛事竞猜。从传统豪门到黑马球队，一篇文章带您看懂整个预选赛格局。',
    content: `<p>2026年欧洲杯预选赛即将拉开帷幕，作为全球最受关注的足球赛事之一，本届预选赛吸引了无数球迷的目光。本文将从各队实力、关键球员、战术体系等多个维度进行全面解析。</p>
<h2>传统豪强：实力依旧强劲</h2>
<p>法国队凭借姆巴佩、格列兹曼等世界级球星，依然是夺冠热门。英格兰队在索斯盖特的带领下，阵容深度令人羡慕。德国队经历换帅后展现全新面貌，穆西亚拉、维尔茨等新生代球员成长迅速。</p>
<p>西班牙队的传控体系依然流畅，佩德里和加维这对黄金双核让斗牛士军团的中场实力位居世界前列。意大利队在经历了世界杯低迷后，正在重整旗鼓。</p>
<h2>黑马球队：不容忽视的力量</h2>
<p>丹麦队在近年来的国际大赛中表现抢眼，整体实力稳步提升。塞尔维亚队拥有弗拉霍维奇、米特罗维奇等顶级前锋，进攻火力不容小觑。挪威队虽然整体实力有限，但哈兰德的存在让任何对手都不敢轻视。</p>
<h2>竞猜策略建议</h2>
<p>在皇冠体育平台进行竞猜时，建议关注以下几点：首先，密切关注球队伤病情况，核心球员的缺席往往对赔率产生重大影响；其次，注意主客场因素，部分球队主场优势极为明显；最后，合理利用皇冠体育提供的实时赔率变化数据，把握最佳投注时机。</p>`,
    category: 'football',
    author: '皇冠体育编辑部',
    date: '2026-08-06',
    views: 12580,
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20atmosphere%20with%20players%20in%20action%2C%20dramatic%20evening%20match%20lighting%2C%20editorial%20sports%20photography%2C%20green%20field%20with%20floodlights%2C%20dynamic%20football%20scene&width=800&height=500&seq=article-football-01&orientation=landscape',
  },
  {
    id: 2,
    title: 'NBA新赛季前瞻：湖人勇士谁能笑到最后？',
    slug: 'nba-new-season-preview-lakers-warriors',
    excerpt: 'NBA新赛季即将开启，湖人队和勇士队作为西部两大豪门，谁能在新赛季走得更远？本文从阵容变化、战术调整、伤病状况等角度进行深入分析，为您的篮球竞猜提供专业参考。',
    content: `<p>NBA新赛季即将全面打响，湖人队和勇士队作为西部最受关注的两支球队，他们的表现直接影响着整个联盟的格局。本文将为您深入分析两队的实力对比。</p>
<h2>洛杉矶湖人：豪华阵容再升级</h2>
<p>湖人队在休赛期进行了多笔重要引援，整体阵容深度得到显著增强。詹姆斯虽然年事已高，但竞技状态依然出色，安东尼·戴维斯在内线的统治力依旧是湖人最大的优势。</p>
<p>新赛季湖人的战术体系更加丰富，外线投射能力的提升让对手的防守压力倍增。如果能够保持健康，湖人无疑是总冠军的有力争夺者。</p>
<h2>金州勇士：库里时代仍未落幕</h2>
<p>斯蒂芬·库里依然是联盟最具威胁的球员之一，他的三分投射能力依旧是勇士最致命的武器。勇士队在新赛季补充了多名年轻有活力的球员，整体阵容更加均衡。</p>
<p>勇士的团队篮球文化是其最大的优势，科尔教练的战术体系经过多年打磨已经极为成熟。新赛季勇士有望在西部赛区取得更好成绩。</p>`,
    category: 'basketball',
    author: '皇冠体育编辑部',
    date: '2026-08-05',
    views: 9850,
    image: 'https://readdy.ai/api/search-image?query=Professional%20NBA%20basketball%20game%20action%20with%20players%20dunking%2C%20dramatic%20arena%20lighting%2C%20editorial%20sports%20photography%2C%20hardwood%20court%20with%20intense%20atmosphere%2C%20dynamic%20basketball%20scene&width=800&height=500&seq=article-basketball-01&orientation=landscape',
  },
  {
    id: 3,
    title: '网球大满贯竞猜攻略：如何精准预测比赛结果',
    slug: 'tennis-grand-slam-betting-guide',
    excerpt: '网球大满贯赛事是竞猜爱好者的盛宴。本文为您分享专业网球竞猜技巧，包括球员状态分析、场地类型影响、历史交锋数据等核心因素，助您提升竞猜准确率。',
    content: `<p>网球大满贯赛事历来是竞猜爱好者的重点关注对象。与其他体育项目不同，网球竞猜有其独特的方法和技巧。本文将分享专业竞猜策略。</p>
<h2>场地类型对比赛的影响</h2>
<p>不同场地类型对比赛结果的影响极为显著。红土场更有利于防守型球员和西班牙、南美选手；草地场则适合发球上网型打法；硬地场相对最为均衡。在竞猜前务必了解比赛场地类型。</p>
<h2>球员状态评估</h2>
<p>网球是个人运动，球员的即时状态至关重要。关注球员近期的比赛成绩、伤病恢复情况以及心理状态，这些因素往往比历史排名更具参考价值。皇冠体育提供的实时赔率变化也能反映市场对球员状态的判断。</p>`,
    category: 'tennis',
    author: '皇冠体育编辑部',
    date: '2026-08-04',
    views: 7230,
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20match%20action%20with%20player%20serving%2C%20dramatic%20court%20lighting%2C%20editorial%20sports%20photography%2C%20clay%20court%20with%20intense%20focus%2C%20dynamic%20tennis%20scene&width=800&height=500&seq=article-tennis-01&orientation=landscape',
  },
  {
    id: 4,
    title: '电竞竞猜入门指南：从LPL到全球总决赛',
    slug: 'esports-betting-beginner-guide',
    excerpt: '电竞竞猜正在成为体育竞猜的新蓝海。本文为新手玩家介绍电竞竞猜的基本知识，包括LPL赛区格局、各队实力排名以及竞猜技巧，帮助您快速上手电竞竞猜。',
    content: `<p>随着电子竞技的蓬勃发展，电竞竞猜已经成为体育竞猜领域增长最快的新兴板块。对于传统体育竞猜玩家来说，电竞竞猜可能相对陌生，本文将为您揭开其神秘面纱。</p>
<h2>LPL赛区：全球最强赛区</h2>
<p>中国LPL赛区目前是全球实力最强的英雄联盟职业联赛赛区。JDG、BLG、TES、EDG等顶级战队在世界范围内都具有极强的竞争力。了解各队的历史战绩和当前状态是竞猜的基础。</p>
<h2>竞猜要点</h2>
<p>电竞竞猜需要关注版本更新对战队的影响，不同版本下同一战队的实力可能天差地别。此外，BO1和BO5赛制下的竞猜策略也有所不同。皇冠体育为您提供全面的电竞赛事赔率和数据分析。</p>`,
    category: 'esports',
    author: '皇冠体育编辑部',
    date: '2026-08-03',
    views: 5640,
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20gaming%20arena%20with%20players%20competing%2C%20dramatic%20stage%20lighting%2C%20editorial%20photography%2C%20large%20screens%20displaying%20game%2C%20intense%20competitive%20gaming%20atmosphere&width=800&height=500&seq=article-esports-01&orientation=landscape',
  },
  {
    id: 5,
    title: '足球竞猜必胜法：五大联赛盘口深度解读',
    slug: 'football-betting-odds-analysis',
    excerpt: '想要在足球竞猜中稳定盈利？本文深度解读欧洲五大联赛的盘口变化规律，从赔率走势、让球盘到大小球，全方位剖析专业竞猜分析方法，让您的投注更加科学。',
    content: `<p>足球竞猜看似简单，实则需要系统的分析方法和丰富的经验积累。本文将从盘口分析的角度，为您揭示专业竞猜的核心技巧。</p>
<h2>赔率变化的秘密</h2>
<p>赔率变化是市场信息的集中体现。当皇冠体育平台上某场比赛的赔率出现大幅波动时，往往意味着有重要信息被市场获知。密切关注赔率走势是竞猜的基本功。</p>
<h2>让球盘深度解读</h2>
<p>让球盘是亚洲盘口中最常见的玩法。理解不同让球幅度背后的含义，结合球队实力、主客场因素和历史交锋数据，能够大幅提升竞猜的准确性。</p>`,
    category: 'football',
    author: '皇冠体育编辑部',
    date: '2026-08-02',
    views: 15230,
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20match%20with%20players%20celebrating%20goal%2C%20dramatic%20stadium%20lighting%2C%20editorial%20sports%20photography%2C%20intense%20football%20action%20on%20green%20pitch&width=800&height=500&seq=article-football-02&orientation=landscape',
  },
  {
    id: 6,
    title: 'CBA新赛季赛程公布：广东辽宁争霸格局延续',
    slug: 'cba-new-season-schedule-guangdong-liaoning',
    excerpt: 'CBA新赛季赛程正式公布，广东宏远和辽宁本钢两支传统豪强依然是夺冠大热门。本文分析新赛季赛程对各队的影响，以及重点赛事的竞猜看点。',
    content: `<p>CBA联赛官方近日公布了新赛季的完整赛程，各支球队的备战工作也已全面展开。作为中国最高水平的篮球联赛，CBA新赛季的竞猜热度持续升温。</p>
<h2>广东宏远：重返巅峰之路</h2>
<p>广东宏远在经历上赛季的调整后，新赛季阵容更加完整。球队在休赛期进行了针对性补强，年轻球员的成长也让球队的整体实力得到提升。</p>
<h2>辽宁本钢：卫冕之路的挑战</h2>
<p>作为卫冕冠军，辽宁本钢在新赛季面临更大的挑战。核心球员的年龄增长和伤病问题是球队需要跨越的最大障碍。</p>`,
    category: 'basketball',
    author: '皇冠体育编辑部',
    date: '2026-08-01',
    views: 4280,
    image: 'https://readdy.ai/api/search-image?query=Professional%20CBA%20Chinese%20basketball%20game%20with%20intense%20action%2C%20dramatic%20arena%20lighting%2C%20editorial%20sports%20photography%2C%20players%20competing%20on%20hardwood%20court&width=800&height=500&seq=article-basketball-02&orientation=landscape',
  },
];